/*eslint-disable */
import React, { useState, useEffect } from 'react'
import { Button, Checkbox, Dropdown, Modal, Radio, Divider, Header, } from 'semantic-ui-react'
import { withFormik, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi } from "semantic-ui-react";
import { connect } from "react-redux";
import CreatAxios from '../axiosComponent/create';
import {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from 'react-i18next';
import { FIELD_IS_REQUIRED,} from '../../utils/validationConstant';
import MyVehicleType from '../apiInputs/myVehicleType';
import cogoToast from "cogo-toast";
const PreferredVehiclesEdit = ({ isSubmitting, handleSubmit, values, vendorId, setFieldValue, touched, errors, t, openModal, CloseModal }) => {
    
    
    return (
        <Modal
            onClose={CloseModal}
            open={openModal}
            size="small"
            className="p-overflow-initial"
        >
            <Modal.Header style={{ fontSize: "14px" }}>{t("preferred_vehicle_types.add.title")}</Modal.Header>
            <Modal.Content>
                <div className="ui form small">
                    <FormUi.Group inline={errors.vehicleTypeIds ? false : true}>
                        <FormUi.Field width="4">
                            <label className="labelName">{t("preferred_vehicle_types.add.vehicle_type.title")}{" "}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="vehicleTypeIds" component={MyVehicleType} restrictSearch={true} multiple placeholder ={t("preferred_vehicle_types.add.vehicle_type.placeholder")}/>
                        {touched.vehicleTypeIds && errors.vehicleTypeIds ? <small className="text-danger">{errors.vehicleTypeIds}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color='green' size="mini" type='button' onClick={CloseModal}>
                    {t("preferred_vehicle_types.add.cancel")}
                </Button>
                <Button type='submit' disabled={isSubmitting} onClick={handleSubmit} size="mini" color="blue">
                    {t("preferred_vehicle_types.add.ok")}
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

const FormikPreferredVehiclesEdit = withFormik({
    
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        return {
            vehicleTypeIds: []
        }
    },
    validationSchema: yup.object({
        vehicleTypeIds: yup.string().required(FIELD_IS_REQUIRED)
    }),
    async handleSubmit(values, { props }) {
        if (props.vendorId && values.vehicleTypeIds && values.vehicleTypeIds.length) { 
            let payload = {
                vendorId : props.vendorId,
                vehicleTypeIds : [...props.vehicleTypeIds , ...values.vehicleTypeIds]
            }
            await CreatAxios({
                url: `transporterVehicleTypeMapping`,
                payload,
            })
                .then((res) => {
                    if(res?.data?.status==200){
                        cogoToast.success(res?.data?.message || "Success", {hideAfter: 2 ,position: "top-right"});
                        window.location.reload()
                    }else{
                        cogoToast.error(res?.data?.message || "Failed to map the vehicle types", {position: "top-right"});
                    }
                })
                .catch((err) => {
                    console.log(err);                    
                });
        }
        else{
            props.CloseModal()
        }
    }

})(PreferredVehiclesEdit)
export default connect(null, {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
})(translate('create_vendor')(FormikPreferredVehiclesEdit))
